export default __webpack_public_path__ + "static/media/febest_ws_logo.54565d6a.svg";